import React from 'react';

import { ScreenProps } from '../ScreenBase';

class ThankYou extends React.Component<ScreenProps> {

  render() {
    return <></>;
  }
}

export default ThankYou;
